/**
 * Derives a grade's Report Card status from its gradeToSubjects entry.
 * @param {{ templatesReleased: boolean, subjectToStandards: Array }} grade
 * @returns {"available"|"in-progress"|"not-started"}
 */
export const getGradeStatus = (grade) => {
    if (grade.templatesReleased) return "available";
    const subjects = grade.subjectToStandards || [];
    const completedCount = subjects.filter((s) => s.completed).length;
    return completedCount === 0 ? "not-started" : "in-progress";
};

/**
 * Builds a Set of applicable grade level strings from location grade tags.
 * Handles the KINDERGARTEN → "K" mapping used throughout the app:
 * location tags use "KINDERGARTEN" but gradeToSubjects uses "K".
 * @param {Array<{ tag: string }>} applicableGrades
 * @returns {Set<string>}
 */
export const buildApplicableSet = (applicableGrades) => {
    const isKinderApplicable = applicableGrades.some((g) => g.tag === "KINDERGARTEN");
    return new Set([...applicableGrades.map((g) => g.tag), ...(isKinderApplicable ? ["K"] : [])]);
};
